import React, {useEffect, useState} from "react";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { slidersData } from '../data.js';

import '../../css/custom-slider.css';

const marks = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6'
};

const NeedSlider = ({title, value, setValue, handleNeedsChange, max, railColor}) => {
    const [message, setMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);

    // Masquer le message après 5 secondes
    const displayMessage = (message) => {
        setShowMessage(true);
        setMessage(message);
    };

    const handleChangeRange = (newValue) => {

        if(newValue > max){
            displayMessage(slidersData[title][newValue]);
            return;
        }
        displayMessage(slidersData[title][newValue]);
        handleNeedsChange(newValue);
        setValue(newValue);
    };

    return (
        <>
        <div className="mutelios-slider tw-flex">
            <p className="mutelios-slider-title">{title}</p>
            <div className="mutelios-slider tw-px-3">
                <Slider
                    min={1}
                    max={6}
                    value={value}
                    marks={marks}
                    onChange={handleChangeRange}
                    styles={{
                        track: {backgroundColor: "#0075BF"},
                        rail: {backgroundColor: `${railColor}`}
                    }}
                />
            </div>
            {showMessage && <div className="tw-text-body-small tw-py-2 tw-px-4">{message}</div>}
        </div>
    </>
    )
}

export default NeedSlider;